<div class="min-h">
  <div class="mainb mb-4">
    <div class="container">
      <span class="titleblog mb-0 ml-3">Blog</span>
      <div class="d-flex justify-content-between align-items-center mt-4">
        <div class="d-flex align-items-center menu-cat ml-3 cp" routerLink="">
          <img src="../assets/img/arrow-l.svg" class="mr-2" alt="arrow">
          <h5 class="back mb-0">Indietro</h5>
        </div>
        <div class="d-flex align-items-center">
          <p class="mr-3 mb-0 d-none d-md-block">Condividi su:</p>
          <ul class="d-flex justify-content-end align-items-center">
            <li class="mr-2">
              <a (click)="social('facebook')"><img src="../assets/img/facebook.svg" alt="facebook" height="26"></a>
            </li>
            <li class="mr-2">
              <a (click)="social('linkedin')"><img src="../assets/img/linkedin.svg" alt="linkedin" height="28"></a>
            </li>
            <li class="mr-2">
              <a (click)="social('email')"><img src="../assets/img/email.svg" alt="email" height="31"></a>
            </li>
            <li class="mr-2">
              <a (click)="social('whatsapp')"><img src="../assets/img/wtsp.svg" alt="whatsapp" height="27"></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row">
      <!-- detail news  -->
      <div class="col-lg-12 px-4 px-md-5" *ngIf="idBlog!=null">
        <div class="row">
          <div class="col-lg-12 blog">
            <div class="row mt-2 mt-md-4">
              <div class="col-lg-6">
                <span class="d-block h5 mb-3">{{detail[0]?.Blog.DtPublication | date: 'dd/MM/yyyy'}}</span>
                <h1 class="titolo mb-3">{{detail[0]?.Blog.Title}}</h1>
                <h2 class="shortdesc"> {{detail[0]?.Blog.ShortDescription}}</h2>
              </div>
              <div class="col-lg-6">
                <img src="{{detail[0]?.Blog.ImageUrl}}" class="img-fluid img-blog mb-4 m-0" *ngIf="detail[0]?.Blog.ImageUrl">
              </div>
            </div>


            <div class="indice" *ngIf="toc.length > 0">
              <div class="d-flex align-items-center justify-content-between">
                <h3 class="titolo mb-0">Indice dei contenuti</h3>
                <a data-toggle="collapse" class="clps" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
                  <img src="../assets/img/maximize.png" alt="maximize" height="20">
                </a>
              </div>
              <div class="mt-3 collapse show" id="collapseExample">
                <div>
                  <ol>
                    <ng-container *ngTemplateOutlet="tocTemplate; context: { items: toc }"></ng-container>
                  </ol>
                </div>
              </div>
            </div>
            <ng-template #tocTemplate let-items="items">
              <ng-container *ngFor="let item of items">
                <li>
                  <a [href]="'#' + item.id" (click)="scrollTo(item.id, $event)">{{ item.text }}</a>
                  <ol *ngIf="item.children.length > 0">
                    <ng-container *ngTemplateOutlet="tocTemplate; context: { items: item.children }"></ng-container>
                  </ol>
                </li>
              </ng-container>
            </ng-template>



            <div class="blog-content">
              <article class="my-4 bodyy" [innerHTML]="blogBody"></article>
            </div>
            <div *ngIf="detail[0]?.Attachments.length!=0">
              <div *ngFor="let item of detail[0]?.Attachments">
                <img [src]="item.Base64" [alt]="item.Caption" *ngIf="item.FileExt=='.jpg' ||item.FileExt=='.jepg' ||item.FileExt=='.png' ">
              </div>
            </div>
            <div *ngIf="detail[0]?.Attachments.length!=0">
              <ng-container *ngFor="let item of detail[0]?.Attachments">
                <div class="d-flex attach align-items-center mb-2" *ngIf="item.FileExt!='.jpg' && item.FileExt!='.jepg' &&item.FileExt!='.png' ">
                  <a href="{{item.Link}}" target="_blank">{{item.Caption}}</a>
                  <span>{{item.Link}}</span>
                </div>
              </ng-container>
            </div>

            <div class="d-flex align-items-center mt-4 mb-5">
              <p class="mr-3 mb-0">Condividi su:</p>
              <ul class="d-flex justify-content-end align-items-center list-unstyled no-bullets">
                <li class="mr-2">
                  <a (click)="social('facebook')"><img src="../assets/img/facebook.svg" alt="facebook" height="26"></a>
                </li>
                <li class="mr-2">
                  <a (click)="social('linkedin')"><img src="../assets/img/linkedin.svg" alt="linkedin" height="28"></a>
                </li>
                <li class="mr-2">
                  <a (click)="social('email')"><img src="../assets/img/email.svg" alt="email" height="31"></a>
                </li>
                <li class="mr-2">
                  <a (click)="social('whatsapp')"><img src="../assets/img/wtsp.svg" alt="whatsapp" height="27"></a>
                </li>
              </ul>
            </div>

          </div>
        </div>
        <div class="d-flex justify-content-center justify-content-md-between align-items-center main-f mt-3">
          <button class="btn btn-w w-auto p-0 mr-auto font-weight-bold text-left" *ngIf="detail[0]?.Blog.IdPrevious" (click)="generateBlogLink(detail[0]?.Blog.IdPrevious, detail[0]?.Blog.TitlePrevious)"> <img loading="lazy" src="../assets/img/arrow-l.svg" alt="arrow" height="18" width="19" class="my-0 m-2">
            <!-- {{detail[0]?.Blog.TitlePrevious}} -->
          </button>

          <button class="btn btn-w w-auto p-0 ml-auto font-weight-bold text-right" *ngIf="detail[0]?.Blog.IdNext" (click)="generateBlogLink(detail[0]?.Blog.IdNext, detail[0]?.Blog.TitleNext)">
            <!-- {{detail[0]?.Blog.TitleNext}} -->
            <img loading="lazy" src="../assets/img/arrow-r.svg" height="18" width="19" class="my-0 m-2">
          </button>
        </div>
        <button class="back-to-top" *ngIf="showBackToTop" (click)="scrollToTop()" aria-label="Torna all'inizio">
          <img src="../assets/img/arrow.png" alt="Torna all'inizio" height="30">
        </button>
      </div>
    </div>
  </div>
</div>

<div itemscope itemtype="https://schema.org/NewsArticle" class="itsc">
  <div itemprop="headline">{{detail[0]?.Blog.Title}}</div>
  <!-- <meta itemprop="image" content="{{detail[0]?.Blog.Base64}}" />
  <meta itemprop="image" content="{{detail[0]?.Blog.Base64}}" /> -->
  <!--<img itemprop="image" src="https://example.com/photos/16x9/photo.jpg" /> -->
  <div>
    <span itemprop="datePublished">
      {{detail[0]?.Blog.DtPublication | date: 'yyyy-MM-ddTHH:mm:ssZ'}}
    </span>
    (last modified
    <span itemprop="dateModified">
      {{detail[0]?.Blog.DtUpdate | date: 'yyyy-MM-ddTHH:mm:ssZ'}}
    </span>
    )
  </div>
  <div>
    <span itemprop="author" itemscope itemtype="https://schema.org/Organization">
      <a itemprop="url" href="https://blog.busandbus.it/">
        <span itemprop="name">Bus&Bus</span>
      </a>
    </span>
  </div>
</div>